import * as types from '../mutation-types/editor-component-manager'

const namespaced = true
export const namespace = 'EditorComponentManager'

const extractComponentsPaths = (components, paths, path = []) => {
    components.forEach((c, i) => {
        const currentPath = [...path, i]
        paths[c.cid] = currentPath
        extractComponentsPaths(c.components, paths, currentPath)
    })
}
const getComponentByCid = (s, cid) => {
    let component = { components: s.editorComponents };
    (s.editorComponentsPaths[cid] || []).forEach(i => component = component.components[i])
    return component
}

// state
const state = {
    editorComponents: [],
    editorComponentsPaths: {},
}

// mutations
const mutations = {
    [types.SET_EDITOR_COMPONENTS](s, editorComponents) {
        const paths = {}
        extractComponentsPaths(editorComponents, paths)
        s.editorComponents = editorComponents
        s.editorComponentsPaths = paths
    },
    [types.UPDATE_EDITOR_COMPONENT](s, {cid, update}) {
        const component = getComponentByCid(s, cid)
        Object.keys(update).forEach(k => component[k] = update[k])
    },
}

// actions
const actions = {
    setEditorComponents({commit}, payload) {
        commit(types.SET_EDITOR_COMPONENTS, payload)
    },
    updateEditorComponent({commit}, payload) {
        commit(types.UPDATE_EDITOR_COMPONENT, payload)
    },
}

// getters
const getters = {
    editorComponents: s => {
        return s.editorComponents
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
